<template>
  <order-list-cache></order-list-cache>
</template>

<script>
  import orderListCache from '@/pagesCache/orderList/index'
  import {mapState} from 'vuex';
  export default {
    layout: 'sidebar',
    activated () {
      let orderAmend = this.orderAmend,
        { isAmend } = orderAmend;
      // 判断是否正在修改订单
      if (isAmend) {
        this.$Modal.confirm({
          title: '提示',
          content: '当前正在修改订单，是否放弃修改？',
          onOk: () => {
            this.$store.commit('booking/user/update', {
              orderAmend: {
                orderData: {},
                isStore: false,
                isAmend: false, // 是否可以改单
                isProducts: false, // 是否可以更改餐品
                isOnlinePay: false, // 是否是线上支付
                isBase: false, // 是否可以更改基础信息（姓名、 电话、 备注、送餐地址）
              }
            });
          },
          onCancel: () => {
            this.$router.back();
          }
        });
      }
    },
    computed: {
      ...mapState({
        orderAmend: state => state.booking.user.orderAmend
      })
    },
    components: {
      orderListCache
    }
  }
</script>



// WEBPACK FOOTER //
// pages/orderList.vue